module.exports = __webpack_public_path__ + "img/huangguan@2x.55ff0882.png";